<form [formGroup]="createBeneConnection" #inviteBene="ngForm" (ngSubmit)="createBeneConnectionForm()">
    <div class="container p-3">
        <div class="form-row">
            <div class="form-group col-md-12">
                <div class="p-field">
                    <label for="firstName">Beneficiary Name</label>
                    <input id="firstName" class="readonly" type="text" disabled="true" pInputText formControlName="firstName"
                        [ngClass]="{ 'im-input-error': (f.firstName.touched || isSubmitted) && f.firstName.errors  }" />
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12">
                <div class="p-field">
                    <label for="communicationEmailId">Communication Email Id</label>
                    <input id="communicationEmailId" type="text" pInputText formControlName="communicationEmailId"
                        [ngClass]="{ 'im-input-error': (f.communicationEmailId.touched || isSubmitted) && f.communicationEmailId.errors  }" />
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-md-12">
                <div class="p-field">
                    <label for="note">Add Note <small>(Optional)</small></label><br />
                    <textarea id="note" type="text" rows="4" pInputTextarea formControlName="note"></textarea>
                </div>
            </div>
        </div>
        <div class="form-row">
            <button type="submit" class="im-btn im-btn-primary im-btn-md" [disabled]="createBeneConnection.invalid">
                Send Invite
            </button>
        </div>
    </div>
</form>
